import Masonry from 'masonry-layout';

(function ($) {
    $(document).ready(function () {

        const grid = document.querySelector('.section-mixed-boxes .grid');
        if (grid) {
            new Masonry(grid, {
                itemSelector: '.grid-item',
                columnWidth: '.grid-item',
                percentPosition: true,
                horizontalOrder: true
            });
        }

    });
})(jQuery);